import { Component, OnInit } from '@angular/core';
import { Translatable } from '@app/types/translatable.type';
import { TimeTrackingSettingsService } from '@app/modules/time-tracking/services/time-tracking-settings.service';
import { NotifyService } from '@app/services';

@Component({
    selector: 'app-time-tracking-approval-flow-settings',
    templateUrl: './approval-flow-settings.template.html',
    styleUrls: ['./approval-flow-settings.style.scss'],
})
export class ApprovalFlowSettings implements OnInit {
    /**
     * For hours tracked without projects, the available approval flows are
     * automatic and manager. The default is manager.
     */
    approvalFlowsNoProject: { [key: string]: Translatable } = {
        manager: 'time-tracking.approvalFlows.manager',
        automatic: 'time-tracking.approvalFlows.automatic',
    };
    approvalFlowNoProject: 'manager' | 'automatic' = 'manager';

    /**
     * Assigned projects count
     */
    automaticCount = 0;
    managerCount = 0;
    ownerCount = 0;

    constructor(
        private timeTrackingSettingsService: TimeTrackingSettingsService,
        private notifyService: NotifyService
    ) {}

    async ngOnInit(): Promise<void> {
        await this.initSettings();
    }

    async onApprovalFlowChange(): Promise<void> {
        await this.timeTrackingSettingsService.set({
            noProjectApprovalFlow: this.approvalFlowNoProject,
        });
        this.notifyService.success('time-tracking.settings.approvalFlowSuccess');
    }

    private async initSettings(): Promise<void> {
        const settings = await this.timeTrackingSettingsService.get();
        this.approvalFlowNoProject = settings.noProjectApprovalFlow ?? 'manager';
        this.automaticCount = settings.counts?.automaticApproval ?? 0;
        this.managerCount = settings.counts?.directManagerApproval ?? 0;
        this.ownerCount = settings.counts?.projectOwnerApproval ?? 0;
    }
}
